import Translation from '../components/pages/Translation/Translation'
import TranslationInfo from '../components/pages/Translation/Info/Info'
import TranslationVideo from '../components/pages/Translation/Video'
import TranslationReservation from '../components/pages/Translation/Reservation'
import TranslationEmbedCodes from '../components/pages/Translation/EmbedCodes'
import TranslationExternalIds from '../components/pages/Translation/ExternalIds'
import TranslationLogo from '../components/pages/Translation/Logo/Logo'
import TranslationWatermark from '../components/pages/Translation/Logo/Watermark'
import TranslationBroadcasting from '../components/pages/Translation/Broadcasting'
import TranslationMonitoring from '../components/pages/Translation/Monitoring/index.vue'
import TranslationStatistic from '../components/pages/Translation/Statistic/Statistic.vue'
import TranslationRestreaming from '../components/pages/Translation/Restreaming/Restreaming.vue'
import TranslationLive from '../components/pages/Translation/Live/TranslationLive.vue'

const TranslationMonitoringSource = () => import('../components/pages/Translation/Monitoring/Source.vue')
const TranslationMonitoringStreams = () => import('../components/pages/Translation/Monitoring/Streams.vue')
const StatisticFilters = () => import('../components/pages/Translation/Statistic/Filters.vue')
const ReservationTableHead = () => import('../components/pages/Translation/TableHeads/Reservation.vue')
const LogoTableHead = () => import('../components/pages/Translation/TableHeads/Logo.vue')
const RestreamingTableHead = () => import('../components/pages/Translation/TableHeads/Restreaming.vue')

export default [
  {
    path: '/translations/:id',
    name: 'translation',
    props: true,
    component: Translation,
    meta: {
      backState: 'translations'
    },
    children: [
      {
        path: 'info',
        name: 'translation.info',
        component: TranslationInfo,
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'live',
        name: 'translation.live',
        component: TranslationLive,
        children: [
          {
            path: ':scoutId',
            component: TranslationLive
          }
        ],
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'logo',
        name: 'translation.logo',
        components: {
          default: TranslationLogo,
          tableHead: LogoTableHead
        },
        meta: {
          backState: 'translations'
        },
        children: [
          {
            path: ':watermarkId',
            name: 'translation-watermark',
            component: TranslationWatermark
          }
        ]
      },
      {
        path: 'restreaming',
        name: 'translation.restreaming',
        components: {
          default: TranslationRestreaming,
          tableHead: RestreamingTableHead
        },
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'video',
        name: 'translation.video',
        component: TranslationVideo,
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'broadcasting',
        name: 'translation.broadcasting',
        component: TranslationBroadcasting,
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'monitoring',
        name: 'translation.monitoring',
        redirect: {
          name: 'translation.monitoring.streams'
        },
        component: TranslationMonitoring,
        children: [
          {
            path: 'source',
            name: 'translation.monitoring.source',
            component: TranslationMonitoringSource
          },
          {
            path: 'streams',
            name: 'translation.monitoring.streams',
            component: TranslationMonitoringStreams
          }
        ],
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'reservation',
        name: 'translation.reservation',
        components: {
          default: TranslationReservation,
          tableHead: ReservationTableHead
        },
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'stats',
        name: 'translation.stats',
        components: {
          default: TranslationStatistic,
          filters: StatisticFilters
        },
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'embedCodes',
        name: 'translation.embedCodes',
        component: TranslationEmbedCodes,
        meta: {
          backState: 'translations'
        }
      },
      {
        path: 'externalIds',
        name: 'translation.externalIds',
        component: TranslationExternalIds,
        meta: {
          backState: 'translations'
        }
      }
    ]
  }
]
